<template lang="pug" >
  .box-item
    .row.row_com_mo(style="margin-left:0px;")
      .col-md-2.col-xs-2.big_icon_com_mo(style="padding:2px;")
        .img-format
          img.img_com(:src="o && o.banner && o.banner[0]")
      .col-md-1.col-xs-1.icon_com_mo
        .icon-div
          img.img_com(:src="o.icon")
      .col-md-9.col-xs-9.text_com_mo(style="font: Bold 17px/21px Proxima Nova;letter-spacing: 0px;color: #4B2D15;") {{o.name}}
    .row.row_com_mo(style="margin-left:0px;")  
      .col-md-2.col-xs-2
      .col-md-1.col-xs-1.icon_com_mo
        img.img_com(:src="o.user ? o.user.avatar: ''")
      .col-md-9.col-xs-9.text_com_mo(style="font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #9F6A28;") {{o.user ? o.user.fullname : ''}}
    .row.row_com_mo(style="margin-left:0px;")
      .col-md-2.col-xs-2
      .col-md-1.col-xs-1.icon_com_mo
        img(src='../../assets/images/community/ic_khoilop.svg')
      .col-md-4.col-xs-4.text_com_mo(style="font: Regular 13px/16px Proxima Nova;letter-spacing: 0px;color: #3A9F00;") {{o.subject ? o.subject.name : ''}}
      .col-md-1.col-xs-1.icon_com_mo
        img(src='../../assets/images/community/ic_thanhvien.svg')
      .col-md-4.col-xs-4.text_com_mo(style="font: Regular 13px/16px Proxima Nova;letter-spacing: 0px;color: #4B2D15;") {{messageText}}
      
    
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
export default {
  props: {
    o: Object
  },
  data() {
    return {
      messageText: '',
      messageTextOld: '',
      count: 0,
      numerMember: 0,
      memberYou: '',
      member_join: this.$t('home.public.member_join'),
      member_self: this.$t('home.public.member_self'),
      member_you: this.$t('home.public.member_you'),
      member_you_self: this.$t('home.public.member_you_self'),
      member_self_other: this.$t('home.public.member_self_other'),
      member_you_other: this.$t('home.public.member_you_other'),
      member_full: this.$t('home.public.member_full'),
      member_other: this.$t('home.public.member_other')
    }
  },
  methods: {
    formatMemberText() {
      if (this.count === 0 && this.numerMember === 1) {
        this.messageText = this.member_self
      } else if (this.count === 0 && this.numerMember === 2) {
        this.messageText = this.member_you.replace('{0}', this.memberYou)
      } else if (this.count === 0 && this.numerMember === 3) {
        this.messageText = this.member_you_self.replace('{0}', this.memberYou)
      } else if (this.count > 0) {
        if (this.numerMember === 1) {
          this.messageText = this.member_self_other.replace('{0}', this.$mycontroller.numberWithCommas(this.count))
        } else if (this.numerMember === 2) {
          this.messageText = this.member_you_other.replace('{0}', this.memberYou).replace('{1}', this.$mycontroller.numberWithCommas(this.count))
        } else if (this.numerMember === 3) {
          this.messageText = this.member_full.replace('{0}', this.memberYou).replace('{1}', this.$mycontroller.numberWithCommas(this.count))
        } else {
          this.messageText = this.member_other.replace('{0}', this.$mycontroller.numberWithCommas(this.count))
        }
      } else {
        this.messageText = this.member_join.replace('{0}', this.$mycontroller.numberWithCommas(this.count))
      }
    },
    async changeText() {
      this.count = this.o.pc_users.length
      let total = 0
      if (!this.$store.getters.isLoggedIn) {
        this.messageText = this.$mycontroller.numberWithCommas(this.count) + ' ' + this.$t('home.public.member')
        this.messageTextOld = this.messageText
      } else {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_USER_JOIN_PC),
          fetchPolicy: 'no-cache',
          variables: {
            pc_id: this.o.id,
            user_id: this.$store.getters.user,
            status: 2
          }
        })
        if (data.pc_user && data.pc_user !== undefined && data.pc_user !== null && data.pc_user.length) {
          this.numerMember = 1
          total++
        }
        if (data.v_front_pc_join_user_aggregate && data.v_front_pc_join_user_aggregate.aggregate !== undefined && data.v_front_pc_join_user_aggregate.aggregate !== null && data.v_front_pc_join_user_aggregate.aggregate.count) {
          this.numerMember += 2
          let countUser = data.v_front_pc_join_user_aggregate.aggregate.count
          total += countUser
          this.memberYou = this.$mycontroller.numberWithCommas(countUser)
        }
        this.count -= total
        this.formatMemberText()
      }
    }
  },
  async created () {
    setTimeout(() => {
      this.changeText()
    }, 100)
  },
  apollo: {
  }
}
</script>

<style lang='scss'>
  // .box-item-com-mo{border-bottom: 1px solid #FAFAFA; padding-bottom: 15px; margin-bottom:15px;
  //   &:last-child{margin-bottom: 0; padding: 0; border:0 none;}
  //   .item-img-com-mo{margin: 0 auto; padding: 0 !important;
  //     img{max-width: 100%; height: auto;}
  //   }
  //   .item-info-com-mo{padding: 0 10px !important;
  //     .child-item-info{margin-bottom:15px;
  //       .icon_com_mo{width: 16px; height: 16px; float:left;
  //         img{border-radius: 50%;overflow:hidden;}
  //       }
  //       .text_com_mo{width: calc(100% - 30px);float:left; margin-left: 10px;}
  //     }
  //   }
  // }
  .big_icon_com_mo{
    .img-format{width: 40px; margin: 0 auto; border-radius: 50%; overflow: hidden;
      img{max-width: 100% !important;  width: auto !important; border-radius: 0 !important;height: 40px; }
    }
  }
  .icon_com_mo {
    .icon-div{width: 16px;margin: 0 auto; border-radius: 50%; overflow: hidden;
      img{height: 16px; max-width: 100%;}
    }
  }
  
@media only screen 
    and (min-device-width : 375px) 
    and (max-device-width : 812px)  { 
    .icon_com_mo {
        padding:0;
        margin-left: 5px;
    }
    .big_icon_com_mo {
        padding: 2px;
    }
    .text_com_mo {
        margin-left:-15px;
        font-size: 11px;
    }
    .row_com_mo {
        margin-top:5px;
    }
}
.img_com {
        border-radius: 50%;
    }
</style>



// WEBPACK FOOTER //
// CommunityItem.vue?6157b8a5